export default __webpack_public_path__ + "static/media/salama.c550777a.png";